import {
  fetchCart,
  checkProductAvailability,
  addSelectedSampleTypeToCart,
  fetchAccountLinks,
} from './api';

import {
  updateCartIndicator,
  getProductsProperties,
  getSelectedSampleTypeProperties,
  handleRequestSampleButtonClick,
  handleSampleTypesSelectChange,
  enableRequestSampleButton,
  disableRequestSampleButton,
  handleNotExistingProduct,
  handleNoExistingProducts,
  changeProductSizeInfoInModal,
  changeProductImageInModal,
  isProductAvailable,
  findRequestSampleModal,
  singleSampleType,
  findSampleTypesSelect,
  hideRequestSampleButton,
  showRequestSampleButton,
  hideRequestInfoButton,
  showRequestInfoButton,
  findAccountLinksToggle,
  toggleAccountLinks,
  setupAccountLinks,
} from './dom';

import { updateAnalyticsObectWithCartData } from '../helpers/adobe-analytics';

import find from 'lodash/find';

const requestSampleModalId = 'modal-request-sample',
  requestSampleModalOpenClass = 'is-open';

export const loadAccountInformation = async () => {
  const accountLinksHTML = await fetchAccountLinks();
  document.querySelector('.js-account-links').innerHTML = accountLinksHTML;
  findAccountLinksToggle().addEventListener('click', toggleAccountLinks);
  setupAccountLinks();
};

export const spreeIntegration = async () => {
  try {
    let cart;
    cart = await fetchCart();
    if (cart) {
      updateAnalyticsObectWithCartData(cart);
      updateCartIndicator(cart.data?.attributes?.item_count);
    }

    const productsProperties = getProductsProperties();
    if (!productsProperties) return;

    const includedPropertiesById = {};
    await Promise.all(
      productsProperties.map(async product => {
        if (!!product) {
          const { id, sampleTypeId } = product;
          if (typeof id === 'undefined' || id === '') return;

          const response = await checkProductAvailability(id);

          if (response.isFail() && sampleTypeId) {
            handleNotExistingProduct(sampleTypeId);
          } else {
            includedPropertiesById[id] = response.success().included;
          }
        }
      })
    );

    if (isProductAvailable()) {
      if (findSampleTypesSelect()) {
        handleSampleTypesSelectChange(event => {
          const sampleTypesSelect = event.target;
          if (
            typeof sampleTypesSelect.value !== 'undefined' &&
            sampleTypesSelect.value !== ''
          ) {
            const id =
              sampleTypesSelect.options[sampleTypesSelect.selectedIndex].dataset
                .productId;

            if (id) {
              showRequestSampleButton();
              enableRequestSampleButton(id);
              hideRequestInfoButton();

              if (
                findRequestSampleModal().classList.contains(
                  requestSampleModalOpenClass
                )
              ) {
                MicroModal.close(requestSampleModalId);
              }

              const productSize = find(includedPropertiesById[id], {
                  attributes: { name: 'size' },
                }),
                selectedSampleTypeProperties = getSelectedSampleTypeProperties();

              changeProductSizeInfoInModal(
                productSize.attributes.value,
                selectedSampleTypeProperties.cartModalInfo.sampleType
              );

              changeProductImageInModal(
                selectedSampleTypeProperties.cartModalInfo.imgSrc
              );
            } else {
              hideRequestSampleButton();
              showRequestInfoButton();
            }
          } else {
            disableRequestSampleButton();
          }
        });

        handleRequestSampleButtonClick(async () => {
          disableRequestSampleButton();
          cart = await addSelectedSampleTypeToCart(1);
          if (cart) updateCartIndicator(cart.item_count);
          enableRequestSampleButton();
        });

        if (singleSampleType()) {
          const sampleTypesSelect = findSampleTypesSelect(),
            sampleTypesOption = sampleTypesSelect.options[0],
            listeningElement = sampleTypesSelect.parentNode.querySelector(
              `[rel="${sampleTypesOption.value}"]`
            ),
            clickEvent = new Event('click');

          if (listeningElement) listeningElement.dispatchEvent(clickEvent);
        }

        findSampleTypesSelect().setAttribute('data-loaded', true);

        const sampleTypesSelect = findSampleTypesSelect(),
          selectedElement = sampleTypesSelect.parentElement.querySelector(
            `.styled-select li[rel="${sampleTypesSelect.value}"]`
          );
        if (selectedElement) selectedElement.dispatchEvent(new Event('click'));
      } else {
        showRequestSampleButton();
        enableRequestSampleButton();
      }

      handleRequestSampleButtonClick(async () => {
        disableRequestSampleButton();
        cart = await addSelectedSampleTypeToCart(1);
        if (cart) updateCartIndicator(cart.item_count);
        enableRequestSampleButton();
      });
    } else {
      handleNoExistingProducts();
    }
  } catch (error) {
    console.error(error);
    if (window.Sentry) {
      Sentry.captureException(error);
    }
    handleNoExistingProducts();
  }
};
